import * as React from "react"
import RandomPools from "./RandomPools"

export default class ConsortiumPools extends React.PureComponent {
  render() {
    return <RandomPools isConsortium />
  }
}